import { DateIntervalValue, OpenDateInterval } from '@client/api';

import { isValidDefinedDate, toUTCDateOrUndefined, toZonedDateStringOrUndefined } from '../dateUtils';
import { isDefinedString } from '../stringUtils';

export const getIntervalStartDate = (dateInterval?: DateIntervalValue | OpenDateInterval | null) => {
  if (!dateInterval) return undefined;
  if (!dateInterval.start) return undefined;
  if (!isDefinedString(dateInterval.start)) return undefined;

  return toUTCDateOrUndefined(dateInterval.start)
};

export const getIntervalEndDate = (dateInterval?: DateIntervalValue | OpenDateInterval | null) => {
  if (!dateInterval) return undefined;
  if (!dateInterval.end) return undefined;
  if (!isDefinedString(dateInterval.end)) return undefined;

  return toUTCDateOrUndefined(dateInterval.end)
};

export const toIntervalStartDateString = (dateInterval?: DateIntervalValue | OpenDateInterval | null) => {
  const date = getIntervalStartDate(dateInterval);
  if (!isValidDefinedDate(date)) return undefined;
  return toZonedDateStringOrUndefined(date);
};

export const toIntervalEndDateString = (dateInterval?: DateIntervalValue | OpenDateInterval | null) => {
  const date = getIntervalEndDate(dateInterval);
  if (!isValidDefinedDate(date)) return undefined;
  return toZonedDateStringOrUndefined(date);
};
